// EPI Staff 端 Service Requests 批量改状态弹窗
// 由 SectionFunction.batchChangeServiceRequestStatus 动态挂载（ReactDOM.render 到 body 下 div）
// 后端：POST /Business/ServiceRequest/ChangeStatus?serviceRequestStatusId=N，body=ids[]
import React from 'react';
import AntDraggableModal from 'components/AntDraggableModal';
import { Form, Select, Button, message } from 'antd';
import { httpClient } from 'util/Api';
import { config } from 'util/config';

export default class ServiceRequestChangeStatusModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      submitting: false,
      statusOptions: [],
      selectedStatusId: null,
    };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    httpClient.get('/Admin/ServiceRequestStatus/GetSelectOptionList')
      .then(({ data }) => {
        if (data.result) {
          const options = (data.data || []).filter(o => o.Value !== 0);
          this.setState({ statusOptions: options });
        }
      })
      .catch(() => message.error('Failed to load status list.'));
  }

  close = (changed) => {
    this.setState({ open: false });
    setTimeout(() => {
      if (changed && this.props.onChanged) this.props.onChanged();
      if (this.props.onClose) this.props.onClose();
    }, 200);
  };

  submit = () => {
    const statusId = this.state.selectedStatusId;
    if (!statusId) {
      message.warning('Please select a status.');
      return;
    }
    this.setState({ submitting: true });
    httpClient.post(
      '/Business/ServiceRequest/ChangeStatus?serviceRequestStatusId=' + statusId,
      this.props.serviceRequestIds
    )
      .then(({ data }) => {
        if (data.result) {
          message.success('Status updated.');
          this.close(true);
        } else {
          message.error(data.message || 'Update failed.');
          this.setState({ submitting: false });
        }
      })
      .catch(() => {
        message.error('Update failed.');
        this.setState({ submitting: false });
      });
  };

  render() {
    return (
      <AntDraggableModal
        title={'Change Status (' + (this.props.serviceRequestIds?.length || 0) + ' selected)'}
        open={this.state.open}
        onCancel={() => this.close(false)}
        confirmLoading={this.state.submitting}
        width={480}
        maskClosable={config.component.Modal.maskClosable}
        footer={[
          <Button key="cancel" onClick={() => this.close(false)}>Cancel</Button>,
          <Button key="ok" type="primary" loading={this.state.submitting} onClick={this.submit}>OK</Button>,
        ]}
      >
        <Form ref={this.formRef} autoComplete="off" size={config.component.size}>
          <Form.Item label="New Status" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
            <Select
              showSearch optionFilterProp="children"
              placeholder="Select status"
              value={this.state.selectedStatusId}
              onChange={(v) => this.setState({ selectedStatusId: v })}
              options={this.state.statusOptions.map(o => ({ value: o.Value, label: o.Key }))}
            />
          </Form.Item>
        </Form>
      </AntDraggableModal>
    );
  }
}
